var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "iar8x7wtnb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.750000 0 0 0 0 0.750000 0 0 0 0 0.750000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "jkxjykpzma",
    d: "M9.167 4.167c.46 0 .833.373.833.833 0 .46-.373.833-.833.833h-5c-.46 0-.834.373-.834.834v9.166c0 .46.373.834.834.834h9.166c.46 0 .834-.373.834-.834v-5c0-.46.373-.833.833-.833.46 0 .833.373.833.833v5c0 1.381-1.119 2.5-2.5 2.5H4.167c-1.381 0-2.5-1.119-2.5-2.5V6.667c0-1.381 1.119-2.5 2.5-2.5zm8.333-2.5c.046 0 .093.004.139.011.06.01.117.026.171.048l.018.008c.027.011.053.024.078.038l.027.016c.019.011.038.024.056.037.035.025.068.054.1.086l-.06-.055c.016.014.032.027.047.042l.013.013.01.01c.018.018.034.036.05.055l.026.036.03.044c.01.014.018.028.025.042l.029.057.016.038c.038.095.058.198.058.307v5c0 .46-.373.833-.833.833-.46 0-.833-.373-.833-.833V4.51l-7.744 7.746c-.299.298-.767.323-1.094.075l-.085-.075c-.325-.326-.325-.853 0-1.179l7.745-7.744H12.5c-.425 0-.775-.318-.827-.728l-.006-.105c0-.46.373-.833.833-.833z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-262 -716) translate(0 651) translate(0 48) translate(262 17)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8pnkpwhqtc",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jkxjykpzma"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#jkxjykpzma"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#iar8x7wtnb)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#8pnkpwhqtc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0H20V20H0z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.5a7761ba.svg";
export { ForwardRef as ReactComponent };